<template>
  <div class="home">
    <HeroSection :data="heroData" />
    <!-- <EditorialIntro :data="editorialData" /> -->
    <div class="section-padding">
      <BusinessMatrix :data="matrixData" @navigate="handleNavigate" />
      <div class="border"></div>
      <BusinessMatrix :data="matrix2Data" @navigate="handleNavigate" />
      <div class="border"></div>
      <BusinessMatrix :data="matrix3Data" @navigate="handleNavigate" />
      <div class="border"></div>
      <BusinessMatrix :data="matrix4Data" @navigate="handleNavigate" />
    </div>
    <Capabilities :data="capabilitiesData" />
    <FeaturedGifts :data="giftsData" />
    <!-- <DataCredibility :data="dataCredibilityData" /> -->
  </div>
</template>

<script>
import HeroSection from "./components/HeroSection.vue";
// import EditorialIntro from "./components/EditorialIntro.vue";
import BusinessMatrix from "./components/BusinessMatrix.vue";
import Capabilities from "./components/Capabilities.vue";
import FeaturedGifts from "./components/FeaturedGifts.vue";
// import DataCredibility from "./components/DataCredibility.vue";

export default {
  name: "Home",
  components: {
    HeroSection,
    // EditorialIntro,
    BusinessMatrix,
    Capabilities,
    FeaturedGifts,
    // DataCredibility,
  },
  data() {
    return {
      heroData: {
        eyebrow: "CULTURE EXPO POWERED BY YUEWENGOU",
        title: "文博聚势 · 粤购赋能",
        subTitle: "深圳文博会线上交易信息公开平台，邀您共赴文化产业新征程",
        copy: "广东展团以 勇立潮头，谱写广东文化产业时代新篇 为主题，聚焦数字创意、影视动漫等前沿领域，充分展现大湾区文化产业创新活力与协同优势。",
        primaryText: "数据监控平台",
        primaryLink: "https://www.yuewengou.com/bigScreen/",
        // primaryLink: `${
        //   process.env.NODE_ENV === "production"
        //     ? "https://www.yuewengou.com"
        //     : "https://ywg-w.s136.ailo.vip"
        // }/bigScreen/`,
        secondaryText: "浏览业务矩阵",
        secondaryLink: "#",
      },
      editorialData: {
        label: "OFFICIAL TRUST & PARTNERSHIP",
        title: "第二十二届中国（深圳）国际文化产业博览交易会",
        subTitle: "广东展团",
        description: `文博会专属B2B与B2C融合门户网站，聚焦甲方参展商产品展示、侧重专业采购商、C端消费者深度了解广东六大文化产业，并设置"广货行天下"、"数实融合"等专区，实现线上线下交易数据互通，为第三方服务商提供数据支撑与服务入口。`,
        cards: [
          {
            icon: "icon-rili",
            title: "活动排期表",
            description:
              "同步查看展会重点活动、时间安排与参与方式，提前规划现场参观路线。",
            bgColor: "#F3EEE5",
            badgeBg: "#E7D8C3",
            badgeBorder: "#D5BE98",
            dividerColor: "#D9CEBD",
            buttonText: "查看活动",
            buttonLink: "/section/1",
          },
          {
            icon: "icon-diannaobofang",
            title: "直播排期表",
            description:
              "掌握直播场次、主题内容与开播时间，线上同步参与重点发布与分享。",
            bgColor: "#FBF8F3",
            badgeBg: "#F2E7D3",
            badgeBorder: "#D8C6A2",
            dividerColor: "#DDD4C4",
            buttonText: "查看直播",
            buttonLink: "/section/2",
          },
          {
            icon: "icon-duihua",
            title: "专题洽淡会",
            description:
              "聚焦重点议题与供需对接，预约专题洽谈，提升合作沟通效率。",
            bgColor: "#F3EEE5",
            badgeBg: "#F2E7D3",
            badgeBorder: "#D8C6A2",
            dividerColor: "#DDD4C4",
            buttonText: "预约洽谈",
            buttonLink: "/section/3",
          },
        ],
      },
      matrixData: {
        label: "EXHIBITOR HUB",
        title: "展商专区",
        description: "找展商，逛内容，一站尽览广东文化消费新面孔。",
        cards: [
          {
            title: "展商名录",
            description: "全部展商，一页纵览，按类可查。",
            image: require("@/assets/images/homepage_matrix_art_trading_platform.png"),
            route: "Exhibitor",
          },
          {
            title: "专题洽谈",
            description:
              "聚焦重点议题与供需对接，预约专题洽谈，提升合作沟通效率。",
            image: require("@/assets/images/homepage_matrix_guangdong_gifts.png"),
            route: "Gift",
          },
        ],
      },
      matrix2Data: {
        label: "TRADING HUB",
        title: "交易专区",
        description: "买实物、藏数字、淘艺术，好货一站直达。",
        cards: [
          {
            title: "广货行天下品牌馆",
            description:
              "汇聚老字号、新智造、文创与内容IP，广东好货，由此出发。",
            image: require("@/assets/images/homepage_matrix_guangdong_gifts.png"),
            route: "Gift",
          },
          {
            title: "数实融合平台",
            description:
              "实物好物、数字好物、艺术佳作，一个入口，打通虚实消费。",
            image: require("@/assets/images/homepage_matrix_digital_heritage.png"),
            route: "Integration",
          },
        ],
      },
      matrix3Data: {
        label: "EVENTS HUB",
        title: "活动专区",
        description:
          "线下活动、线上直播，让文化消费不止于静态展示，更是持续发生的现场直播。",
        cards: [
          {
            title: "活动排期",
            description:
              "同步查看展会重点活动、时间安排与参与方式，提前规划现场参观路线。",
            image: require("@/assets/images/homepage_matrix_southern_cultural_mall.png"),
            route: "CulturalMall",
          },
          {
            title: "直播排期",
            description:
              "掌握直播场次、主题内容与开播时间，线上同步参与重点发布与分享。",
            image: require("@/assets/images/homepage_matrix_art_trading_platform.png"),
            route: "ArtTrade",
          },
        ],
      },
      matrix4Data: {
        label: "SERVICE HUB",
        title: "服务专区",
        description: "核心能力与外部生态，一站配齐文化产业所需专业服务。",
        cards: [
          {
            title: "版权服务",
            description:
              "数字版权登记、交易、确权，依托南方文交所专业资质，为文化资产保驾护航。",
            image: require("@/assets/images/homepage_matrix_southern_cultural_mall.png"),
            route: "CulturalMall",
          },
          {
            title: "溯源服务",
            description:
              "从产地到手中，一物一码，让每一件文化好物来源可追、真伪可查、品质可信。",
            image: require("@/assets/images/homepage_matrix_digital_heritage.png"),
            route: "Heritage",
          },
        ],
      },
      capabilitiesData: {
        label: "DUAL VENUES ONLINE TRADE",
        title: "联动广东双馆展区・打通线上交易快车道",
        footer:
          "粤文购平台依托南方数链、区块链技术底座，严格筑牢交易安全防线，实现展商信息、交易动态公开可溯，让文化交易更安全透明高效，助力粤港澳文化产业高质量发展生态，打造永不落幕的文博会交易新场景。",
        cards: [
          {
            title: "技术安全",
            description: "南方数联 × 区块链双技术筑牢交易安全防线",
            image: require("@/assets/images/homepage_capability_compliance_trade.png"),
            bgColor: "#FBF8F3",
            borderColor: "#DDD4C4",
          },
          {
            title: "信息公开闭环",
            description: "展商信息全公示  |  交易动态全留痕  |  链上数据全可溯",
            image: require("@/assets/images/gifts_still_life_interior.png"),
            bgColor: "#E8EEF4",
            borderColor: "#D7E0EA",
          },
          {
            title: "长效场景赋能",
            description: "双线联动互通，串联广东展团资源生态",
            image: require("@/assets/images/homepage_capability_appraisal_storage.png"),
            bgColor: "#FBF8F3",
            borderColor: "#DDD4C4",
          },
        ],
      },
      giftsData: {
        label: "KEY FOCUS GUANGDONG GIFTS",
        title: "重点业务聚焦：广东礼物",
        mainImage: require("@/assets/images/img401.jpg"),
        lead: "一份广东礼，十足平靓正",
        description:
          "广东礼物是广东省官方指导打造的省级公共品牌，融合岭南非遗、地理标志产品与现代设计，构建文创孵化、产品优选与全渠道销售生态，打造兼具文化特色与消费品质的广东文旅名片。",
        cards: [
          {
            title: "罗浮山下四时春 · 文创礼盒",
            subtitle: "拾禾（惠州）文化创意有限公司",
            description:
              "「罗浮山下四时春」文创礼盒围绕粤港澳大湾区文旅融合与百千万工程打造，以苏东坡寓惠文化为脉络，融合罗浮山、西湖、合江楼等惠州地标及诗词书法元素，携手东平窑非遗传承人与地方书法家，共同呈现兼具艺术审美、实用功能与文化叙事的高端文创礼品。",
            image: require("@/assets/images/img404.jpg"),
          },
          {
            title: "马上有钱 · 青花瓷储蓄罐",
            subtitle: "大埔青花瓷非遗工坊",
            description:
              "大埔是中国青花瓷之乡，本作品采用非遗釉下纯手绘技法，将青花瓷、卡通形象、储蓄罐与马上有钱的吉祥寓意融入设计，使工艺瓷更具日用与观赏价值。作品以青花颜料经1350℃高温一次烧制而成，造型独特、便于携带，是旅游纪念及馈赠亲友的佳品。",
            image: require("@/assets/images/img403.jpg"),
          },
          {
            title: "八方来财 · 金属立体冰箱贴",
            subtitle: "广东省博物馆",
            description:
              "设计源自馆藏文物潮州木雕通雕蟹篓，原作由张鉴轩、陈舜羌师徒共同雕刻而成。作品运用多层镂空通雕与圆雕技艺，将蟹篓与螃蟹刻画得栩栩如生。产品以电镀工艺还原细节，蟹篓可开启，内置小螃蟹，表面螃蟹亦可拆卸，整体灵动精巧。",
            image: require("@/assets/images/img402.jpg"),
          },
        ],
      },
      dataCredibilityData: {
        label: "DATA CREDIBILITY",
        title: "用数据强化平台规模与可信度",
        bgImage: require("@/assets/images/homepage_data_credibility_bg.png"),
        metrics: [
          { value: "50亿+", label: "累计交易额" },
          { value: "100万+", label: "注册用户" },
          { value: "10000+", label: "上架藏品" },
          { value: "99.9%", label: "客户满意度" },
        ],
        trendLabel: "交易趋势 / TREND",
        trendDescription:
          "数据区以官网展示方式呈现平台规模与发展趋势，让可信度在清晰表达中自然建立。",
        chartBars: [
          { height: 88, color: "#C6A96B" },
          { height: 132, color: "#E6D7B5" },
          { height: 146, color: "#C6A96B" },
          { height: 210, color: "#DCE5EF" },
          { height: 194, color: "#E6D7B5" },
          { height: 261, color: "#C6A96B" },
        ],
      },
    };
  },
  methods: {
    handleNavigate(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.home {
  @include theme-variable(bg-page);
}
.section-padding {
  padding: 40px 0;
  background-color: #194670;

  @include tablet {
    padding: 32px 0;
  }

  @include mobile {
    padding: 20px 0;
  }
}

.border {
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
  margin: 0 40px;

  @include tablet {
    margin: 0 32px;
  }

  @include mobile {
    margin: 0 20px;
  }
}
</style>
